;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import React from "react"
import Link from "next/link"
import { cn } from "../../../../lib/utils"

/**
 * DesktopNavBarButton's pill (BUTTON_CLASSES) on a single link, so there is no
 * button nested inside the anchor. The global `a` rule (underline, hover
 * color) is overridden explicitly.
 */
const LINK_CLASSES =
  "ml-[6px] inline-flex h-[42px] min-w-16 cursor-pointer items-center justify-center rounded-[100px] border-0 bg-transparent px-[15px] font-roboto text-[0.875rem] leading-[1.75] font-medium tracking-[0.02857em] uppercase whitespace-nowrap text-[#092C3C] no-underline transition-colors duration-250 hover:bg-[rgba(9,44,60,0.08)] hover:text-[#092C3C] hover:no-underline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#092C3C]"

/**
 * Current page: dark pill with white text (14.6:1). White or lemon fills on
 * the #00B2FF bar fall below 3:1, so they are not used.
 */
const ACTIVE_CLASSES = "bg-[#092C3C] text-white hover:bg-[#0F3D52] hover:text-white"

/**
 * Admin top-bar item. The active item gets aria-current: "page" on its own
 * list page, "true" on a page inside its section (see adminNavAriaCurrent).
 */
export default function AdminNavLink({
  href,
  active = false,
  ariaCurrent = "page",
  className,
  children,
}: {
  href: string
  active?: boolean
  ariaCurrent?: "page" | "true"
  className?: string
  children: React.ReactNode
}) {
  return (
    <Link
      href={href}
      aria-current={active ? ariaCurrent : undefined}
      className={cn(LINK_CLASSES, active && ACTIVE_CLASSES, className)}
    >
      {children}
    </Link>
  )
}
